import { render, staticRenderFns } from "./FlowNode.vue?vue&type=template&id=63b27c76&scoped=true&"
import script from "./flow-node.ts?vue&type=script&lang=ts&"
export * from "./flow-node.ts?vue&type=script&lang=ts&"
import style0 from "./FlowNode.vue?vue&type=style&index=0&id=63b27c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b27c76",
  null
  
)

export default component.exports